import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4 stats-box position-relative" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-6" }
const _hoisted_5 = {
  class: "chart-position",
  style: {"max-width":"160px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"col-lg-6\"><span>Clicks</span><div class=\"d-flex align-items-center mb-4\"><h3 class=\"fs-20 mt-1 mb-0\">4,500</h3><span class=\"d-inline-block bg-success text-success bg-opacity-25 px-2 rounded-1 fs-12 fw-medium d-flex align-items-center ms-2\"><i class=\"ri-arrow-up-s-fill fs-20 lh-1 me-1\"></i> 37.5% </span></div><span class=\"fs-12\">Last 30 days</span></div>", 1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.isClient)
              ? (_openBlock(), _createBlock(_component_apexchart, {
                  key: 0,
                  type: "area",
                  height: "150",
                  options: _ctx.clicksChart,
                  series: _ctx.clicks
                }, null, 8, ["options", "series"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}